import { useEffect, useRef } from "react"
import { postMessageToChildIframe } from "../../utils/CommonUtils"
import { useDispatch, useSelector } from "react-redux"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { EC_APP_URL, EC_URL } from "../../utils/Config"
import { getSessionItem } from "../../utils/storageUtils"
import { CC_PRODUCT_ID, LANG_LIST, OXE_DISCONNECTION, TOKEN_2 } from "../../utils/Constants"
import { useNavigate } from "react-router-dom"
import { handleOXEDisconnection } from "../../store/actions/OxeActions"


const ExpertConfig = () => {

    const language = useSelector(state => state.common.language)
    const oxeAndClientInfo = useSelector(state => state.oxe.oxeAndClientInfo)
    const dispatch = useDispatch()
    const iframeRef = useRef()
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(setContentLoading(true))

        window.addEventListener("message", (event) => {
            if (event.origin === EC_APP_URL) {
                console.log("UMC: event from OXE WBM", event)

                if (event.data?.type === "init") {
                    authHandler()
                } else if (event.data?.type === "logout") {
                    if(event.data.data === OXE_DISCONNECTION) {
                        dispatch(handleOXEDisconnection())
                    } else {
                        console.log("EC: Logout")
                        navigate("/logout")
                    }
                }
            }
        })

        return () => {
            window.removeEventListener("message", () => console.log("message event listener removed"));
        };

    }, [language])

    const authHandler = () => {
        const lang = LANG_LIST.find(lang => lang.key === language) 

        const authData = {
            backend: `${EC_URL}/`,
            token: getSessionItem(TOKEN_2),
            ccproductid: getSessionItem(CC_PRODUCT_ID),
            nodeNumber: oxeAndClientInfo?.nodeNumber || "",
            clientName: oxeAndClientInfo?.clientName,
            language: lang.value
        }
        postMessageToChildIframe(iframeRef, { type: "login", data: authData })
        dispatch(setContentLoading(false))
    }

    return <div id="expert-config" style={{ height: "100%" }}>
        <iframe
            key={language}
            title="expert-configuration"
            ref={iframeRef}
            src={EC_APP_URL}
            style={{ width: "100%", height: "100%", border: 0 }}
        />

    </div>
}

export default ExpertConfig